import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsChocolateyComponent } from './simple-icons-chocolatey.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsChocolateyComponent ],
    exports:      [ SimpleIconsChocolateyComponent ],
    bootstrap:    []
})
export class SimpleIconsChocolateyModule {}
